import { useGateway } from '@ad-lucy/gateway-provider';
import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import { getAppConfig } from '@modules/config/appConfig';
import RemoteClientReporting from '@modules/remotes/clientReporting';
import { Suspense, useMemo } from 'react';
import type { MfClientReportingAppConfig } from './ClientReporting.types';

function ClientReporting() {
  const appConfig = getAppConfig();
  const gateway = useGateway();

  const clientReportingAppConfig = useMemo<MfClientReportingAppConfig>(
    () => ({
      API_ROOT: appConfig.API_ROOT,
      IMG_URL: appConfig.IMG_URL,
      THEME_DEFAULT: appConfig.THEME_DEFAULT,
      THEME_URL: appConfig.THEME_URL,
    }),
    [appConfig],
  );

  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteClientReporting
          appConfig={clientReportingAppConfig}
          gateway={gateway}
        />
      </Suspense>
    </ErrorBoundary>
  );
}

export default ClientReporting;
